module.exports = __webpack_public_path__ + "static/media/мост.8cde42de.jpg";